export default function SuccessCheck({ width = 24, height = 24 }) {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33317 28.5003C9.33317 23.5496 11.2998 18.8017 14.8005 15.301C18.3012 11.8003 23.0491 9.83366 27.9998 9.83366C32.9505 9.83366 37.6985 11.8003 41.1992 15.301C44.6998 18.8017 46.6665 23.5496 46.6665 28.5003C46.6665 33.451 44.6998 38.199 41.1992 41.6997C37.6985 45.2003 32.9505 47.167 27.9998 47.167C23.0491 47.167 18.3012 45.2003 14.8005 41.6997C11.2998 38.199 9.33317 33.451 9.33317 28.5003ZM27.9998 5.16699C15.1128 5.16699 4.6665 15.6133 4.6665 28.5003C4.6665 41.3873 15.1128 51.8337 27.9998 51.8337C40.8868 51.8337 51.3332 41.3873 51.3332 28.5003C51.3332 15.6133 40.8868 5.16699 27.9998 5.16699ZM40.7328 22.5667L37.4335 19.2673L25.6665 31.0343L19.1495 24.5173L15.8502 27.8167L25.6665 37.633L40.7328 22.5667Z"
        fill="#11A75C"
      />
    </svg>
  );
}
